/** KAN-1003: публичные цены (страница /prices, без входа). */
import { useQuery } from '@tanstack/react-query';
import { publicPricesApi } from '@/services/api/publicPrices';

export const PUBLIC_PRICES_QUERY_KEY = ['public-prices'] as const;

export function usePublicPrices() {
  return useQuery({
    queryKey: PUBLIC_PRICES_QUERY_KEY,
    queryFn: publicPricesApi.getPrices,
  });
}
